import { useCallback, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { fetchExperiencePaymentHistory } from "store/reservations"
import { mergeOrderPaymentHistory } from "./orderPayments"

// An order's payment history: every experience's payments, loaded together for the reservation's
// one Payments panel. `reload(uuid)` refetches one experience after a payment action on it, or all.
export const useOrderPaymentHistory = (experiences, isEnabled) => {
  const dispatch = useDispatch()
  const [historyByUuid, setHistoryByUuid] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const uuidKey = experiences.map((entry) => entry.uuid).join(",")

  const load = useCallback(
    async (uuids) => {
      setIsLoading(true)
      const results = await Promise.allSettled(uuids.map((uuid) => dispatch(fetchExperiencePaymentHistory(uuid))))
      setHistoryByUuid((prev) => {
        const next = { ...prev }
        // A booking whose history failed to load keeps what it showed before.
        results.forEach((result, index) => {
          if (result.status === "fulfilled") next[uuids[index]] = result.value
        })
        return next
      })
      setIsLoading(false)
    },
    [dispatch]
  )

  useEffect(() => {
    if (isEnabled && uuidKey) load(uuidKey.split(","))
  }, [isEnabled, uuidKey, load])

  const reload = useCallback((uuid) => load(uuid ? [uuid] : uuidKey.split(",")), [load, uuidKey])

  return { history: mergeOrderPaymentHistory(historyByUuid, experiences), isLoading, reload }
}
